import { ILineStyle } from "../../../../base/domain/drawing";
import { IPropertyEditable } from "../../../../base/domain/system/edit";
import { HisInformationSetting } from "../../../../base/domain/his";
import { ICopyLinkedCheckBehavior, PatientProfileCheckKinds, TranscribeTargetKinds } from "../../../../documaker/domain/format/objects";
import { IFormatObjectEditable } from "../IFormatObjectEditable";
import { IFormatSpecification } from "../IFormatSpecification";
import { ICircleSelectObject } from "../objects";
import { ICopyLinkedCheckBehaviorPropertyEditable, ILineStylePropertyEditable } from "../properties";
import { AbstractCheckableObjectEditor } from "./AbstractCheckableObjectEditor";

export class CircleSelectObjectEditor extends AbstractCheckableObjectEditor<ICircleSelectObject> implements ICopyLinkedCheckBehaviorPropertyEditable, ILineStylePropertyEditable {
  constructor(source: ICircleSelectObject | CircleSelectObjectEditor, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
    this._copyLinkedCheckBehavior = this.createPropertyEditor(s => s.copyLinkedCheckBehavior, (s, v) => s.copyLinkedCheckBehavior = v);
    this._lineStyle = this.createPropertyEditor(s => s.lineStyle, (s, v) => s.lineStyle = v);
  }

  getSelectableHisInformations(): HisInformationSetting[] {
    return this._specification.objects.circleSelect.hisInformations;
  }

  protected _copyLinkedCheckBehavior: IPropertyEditable<ICopyLinkedCheckBehavior>;
  protected _lineStyle: IPropertyEditable<ILineStyle>;

  copyLinkedCheckBehavior(): IPropertyEditable<ICopyLinkedCheckBehavior> {
    return this._copyLinkedCheckBehavior;
  }

  lineStyle(): IPropertyEditable<ILineStyle> {
    return this._lineStyle;
  }

  isPatientProfileCheckKindSelectable(): boolean {
    // v45ではHIS情報の場合は選択不可になる.(円選択だけ.)
    return !this.getHisInformationItemFromKey(this.hisInformationKey().getValue());
  }

  getSelectablePatientProfileCheckKinds(): PatientProfileCheckKinds[] {
    return this._specification.objects.circleSelect.patientProfileCheckKinds;
  }

  isGroupScopeSelectable(): boolean {
    return this._specification.objects.circleSelect.isGroupScopeSelectable;
  }

  getSelectableTranscribeTargets(): TranscribeTargetKinds[] {
    return this._specification.objects.circleSelect.transcription.targets;
  }

  getTypeName(): string {
    return "円選択";
  }

  clone(): IFormatObjectEditable {
    return new CircleSelectObjectEditor(this);
  }
}
